import type { ReactNode } from 'react';

/**
 * Заглушка зоны консоли.
 *
 * ЭТАП 1 СТРОИТ КАРКАС. Зона обозначена подписью и своим местом; содержимое
 * приходит на этапе 2 из реестра эталона. Заглушка называет зону и ссылается
 * на пункты реестра, которые в ней окажутся, - иначе по каркасу нельзя
 * проверить, что место под зону вообще предусмотрено.
 */
export interface PlaceholderProps {
  title: string;
  /** Что здесь будет. Одной строкой, своими словами. */
  hint?: string;
  /** Идентификаторы пунктов реестра, которые наполнят зону. */
  registry?: string[];
  /** Содержимое каркаса, если у зоны уже есть поведение (переключатели режимов). */
  children?: ReactNode;
  className?: string;
  /** Плотная заглушка: для мест в одну строку вроде ячеек верхней полосы. */
  compact?: boolean;
  /** Метка места в полосе - по ней зону находят сценарии. */
  'data-topbar'?: string;
}

export function Placeholder({
  title,
  hint,
  registry,
  children,
  className = '',
  compact = false,
  ...rest
}: PlaceholderProps) {
  return (
    <div
      {...rest}
      data-zone={title}
      className={[
        'border-foreground/15 text-foreground/80 rounded-lg border border-dashed',
        compact ? 'px-2 py-1' : 'p-3',
        className,
      ].join(' ')}
    >
      <p
        className={
          compact
            ? 'text-xs leading-none font-medium tracking-wide uppercase'
            : 'text-xs font-medium tracking-wide uppercase'
        }
      >
        {title}
      </p>
      {hint !== undefined && !compact && <p className="mt-1 text-sm">{hint}</p>}
      {registry !== undefined && registry.length > 0 && !compact && (
        <p className="text-foreground/80 mt-1 font-mono text-sm break-all">
          {registry.join(' · ')}
        </p>
      )}
      {children}
    </div>
  );
}
